import React, { useState, useEffect } from 'react';
import { checkServerConnection, getLocalServerPort } from '../config';
import './ConnectionStatus.css';

const ConnectionStatus = () => {
  const [isConnected, setIsConnected] = useState(null); // null = checking, true = connected, false = disconnected
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    checkConnection();
    // Check connection every 10 seconds
    const interval = setInterval(checkConnection, 10000);
    return () => clearInterval(interval);
  }, []);

  const checkConnection = async () => {
    const connected = await checkServerConnection();
    setIsConnected(connected);
  };

  const handleRetry = () => {
    setIsConnected(null);
    checkConnection();
  };

  if (isConnected === null) {
    return (
      <div className="connection-status checking">
        <span className="status-dot">●</span>
        <span>Checking connection...</span>
      </div>
    );
  }

  if (isConnected) {
    return (
      <div
        className="connection-status connected"
        onClick={() => setShowDetails(!showDetails)}
        title="Click for details"
      >
        <span className="status-dot">●</span>
        <span>Connected to local server</span>
        {showDetails && (
          <div className="connection-details">
            <div className="detail-item">
              <strong>Server:</strong> localhost:{getLocalServerPort()}
            </div>
            <div className="detail-item">
              <strong>Status:</strong> Connected
            </div>
            <div className="detail-item privacy-note">
              🔒 All data stays on your machine
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="connection-status disconnected">
      <span className="status-dot">●</span>
      <span>Local server not running</span>
      <button className="retry-button" onClick={handleRetry}>
        Retry
      </button>
      <div className="connection-help">
        <p>To use PTADash, start the local server:</p>
        <code>./run.sh</code>
        <p className="help-text">
          The local server must be running on your computer to access your journal files.
        </p>
      </div>
    </div>
  );
};

export default ConnectionStatus;
